export const Assistence = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.999 19.183c-5.063 0-9.182-4.12-9.182-9.184C.817 4.936 4.936.817 9.999.817c5.064 0 9.184 4.119 9.184 9.182 0 5.064-4.12 9.184-9.184 9.184zM9.999 0C4.486 0 0 4.485 0 10c0 5.514 4.486 10 9.999 10C15.513 20 20 15.514 20 10 20 4.484 15.513 0 9.999 0z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.841 13.996c.409 0 .726.3.726.706v.3c0 .405-.317.72-.726.72a.714.714 0 01-.725-.72v-.3c0-.406.317-.706.725-.706zm-.015-1.247c-.196 0-.362-.165-.393-.405l-.166-1.682c-.03-.286.151-.496.438-.526 1.603-.12 2.616-.826 2.616-2.087v-.03c0-1.082-.847-1.953-2.207-1.953-1.013 0-1.814.436-2.494 1.171a.628.628 0 01-.409.166.528.528 0 01-.544-.526c0-.135.06-.285.182-.405C7.649 5.6 8.678 5 10.144 5c2.04 0 3.386 1.262 3.386 2.974v.03c0 1.877-1.421 2.808-3.144 3.048l-.106 1.292c-.03.24-.181.405-.393.405h-.06z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
